import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';

export const providePrimengCore = () =>
  providePrimeNG({
    theme: {
      preset: Aura,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'primeng',
          order: 'app-styles, primeng-overrides, primeng',
          darkModeSelector: '.my-app-dark'
        },
      },
    },
  });
